import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {
  authenticatUser: any;

  constructor(private router: Router,private localStorageService:LocalStorageService){}

  ngOnInit(): void {
    initFlowbite();
    this.authenticatUser =this.localStorageService.get('user_id')
  }

  public navigateTo(route: string){
    this.router.navigateByUrl(route); 
  }
}
